import Repository from "@/repository";
import router from "@/router"
import { useRoute } from 'vue-router';

export default {
  state: {
    files: []
  },
  actions: {
    async createFile({ commit }, file) {
      commit("setIsLoader", true);
      const { value, error } = await Repository.AttachmentsActions.create(file)
      if (!error) {
        commit("setFiles", value)
      }
      commit("setIsLoader", false);
    },
    async deleteFile({ commit }, { id, route }) {
      commit("setIsLoader", true);
      const { value, error } = await Repository.AttachmentsActions.delete(id)
      if (!error) {
        commit("deleteFile", id)
        if (route === "create-lead" || route === "edit-lead") {
          commit("deleteFileFromLead", id)
        }
        if(route === "create-counterpartie" || route === "edit-counterpartie") {
          commit("deleteFileFromCounterpartie", id)
        }
      }
      commit("setIsLoader", false);
    },
  },
  mutations: {
    setFiles(state, value) {
      if (!value) {
        state.files = []
        return
      }
      state.files.push(value)
    },
    deleteFile(state, id) {
      state.files = state.files.filter(i => i.id !== id)
    }
  }
};
